import { render, staticRenderFns } from "./TournamentRanking.vue?vue&type=template&id=f8f2c58e&scoped=true"
import script from "./TournamentRanking.vue?vue&type=script&lang=js"
export * from "./TournamentRanking.vue?vue&type=script&lang=js"
import style0 from "./TournamentRanking.vue?vue&type=style&index=0&id=f8f2c58e&prod&scoped=true&lagn=scss&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f2c58e",
  null
  
)

export default component.exports